<template>
  <van-popup v-model="show" round position="bottom">
    <div class="content">
      <h1>如何查询IMEI码</h1>
      <div class="info">在拨号界面输入<span>*#06#</span></div>
      <div>
        <img src="../assets/imei.png" />
      </div>
      <button @click="gotoImei">直接查询</button>
    </div>
  </van-popup>
</template>
<script>
import Vue from "vue";
import { Popup } from "vant";

Vue.use(Popup);
export default {
  data() {
    return {
      show: false,
    };
  },
  props: ["value"],
  watch: {
    show(val) {
      this.$emit("input", val);
    },
    value(val){
      this.show = val
    }

  },
  methods: {
    gotoImei() {
      window.location.href = "tel:*#06#";
      this.show = false;
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  text-align: center;
  padding: 0 20px 20px 20px;
  h1 {
    margin: 0;
    border: none;
    font-size: 18px;
    font-weight: bold;
  }
  .info {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 20px;
    span {
      color: #d35050;
    }
  }
  img {
    width: 30%;
  }
  button {
    outline: none;
    border: none;
    height: 34px;
    margin-top: 16px;
    line-height: 34px;
    border-radius: 17px;
    color: white;
    width: 100%;
    background: linear-gradient(to right, #e0ac77, #ba8859);
  }
}
</style>
